import { useEffect, useState } from 'react';

/**
 * iOS Chrome/Safari: `position:fixed; bottom:0` anchors to the layout viewport,
 * which can extend below the visible visual viewport when browser chrome is shown.
 * Returns the px offset to lift the bar to the visible screen bottom.
 */
export function useVisualViewportBottomOffset(): number {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const update = () => {
      const vv = window.visualViewport;
      if (!vv) {
        setOffset(0);
        return;
      }
      setOffset(Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop)));
    };

    update();
    const vv = window.visualViewport;
    vv?.addEventListener('resize', update);
    vv?.addEventListener('scroll', update);
    window.addEventListener('orientationchange', update);

    return () => {
      vv?.removeEventListener('resize', update);
      vv?.removeEventListener('scroll', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);

  return offset;
}
